import { render, staticRenderFns } from "./FormularioCredito.vue?vue&type=template&id=28d60c38&scoped=true"
import script from "./FormularioCredito.vue?vue&type=script&lang=js"
export * from "./FormularioCredito.vue?vue&type=script&lang=js"
import style0 from "./FormularioCredito.vue?vue&type=style&index=0&id=28d60c38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d60c38",
  null
  
)

export default component.exports